import { useCallback, useMemo } from 'react';
import { ButtonProps } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import useExport from '@/hooks/useExport';
import { dateToPeriodFormat } from '@/utils/format';
import ExportButton from './ExportButton.component';

interface ExportButtonContainerProps extends ButtonProps {
  documentTitle?: string;
}

const ExportButtonContainer = function ({
  documentTitle,
  ...props
}: ExportButtonContainerProps): JSX.Element {
  const { pathname } = useLocation();
  const { parentComponentRef } = useExport();

  const contentToBeExported = useCallback(() => {
    if (parentComponentRef && parentComponentRef.current) {
      return parentComponentRef.current;
    }

    return null;
  }, [parentComponentRef]);

  const documentTitleToBeExported = useMemo(() => {
    const pageName = pathname.slice(1, pathname.length);

    return documentTitle || `Exported Zion [${pageName}] page - ${dateToPeriodFormat(new Date())}`;
  }, [documentTitle, pathname]);

  const exportPage = useReactToPrint({
    content: contentToBeExported,
    documentTitle: documentTitleToBeExported,
    removeAfterPrint: true,
  });

  const handleOnExport = (): void => {
    exportPage();
  };

  return <ExportButton onExport={handleOnExport} {...props} />;
};

export default ExportButtonContainer;
